import * as React from "react"
import * as HoverCardPrimitive from "@radix-ui/react-hover-card"

import { cn } from "~/lib/utils"

const HoverCard: React.FC<React.ComponentProps<typeof HoverCardPrimitive.Root>> = ({
  openDelay = 150,
  closeDelay = 100,
  ...props
}) => <HoverCardPrimitive.Root openDelay={openDelay} closeDelay={closeDelay} {...props} />

const HoverCardTrigger = HoverCardPrimitive.Trigger

const HoverCardPortal = HoverCardPrimitive.Portal

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={className} {...props} />
))
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName

export { HoverCard, HoverCardTrigger, HoverCardPortal, HoverCardContent }
